import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import SearchInput from 'search/inputs/SearchInput';

interface MultiSelectSearchEditorProps {
  config: Array<string> | null;
  onChangeConfig: (config: Array<string>) => void;
  modelTypes: Array<ModelTypeConstants>;
  disabled?: boolean;
}

export default function MultiSelectSearchEditor({
  config,
  onChangeConfig,
  modelTypes,
  disabled,
}: MultiSelectSearchEditorProps): JSX.Element {
  return (
    <SearchInput
      autoFocus={false}
      disabled={disabled}
      disableTyping={false}
      isMulti={true}
      onRemove={(itemToRemove) => {
        onChangeConfig((config ?? []).filter((item) => item !== itemToRemove));
      }}
      onSelect={(itemToAdd) => {
        if (itemToAdd != null) {
          onChangeConfig(config == null ? [itemToAdd] : [...config, itemToAdd]);
        }
      }}
      placeholder=""
      selected={config ?? []}
      types={modelTypes}
    />
  );
}
